export default __webpack_public_path__ + "static/media/zenodo-upload-list.e2242efb.png";